import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RbidosLeadModel, RbidosLeadCreateModel } from 'Pages/lead'
import { Callback } from 'Src/types/utilTypes'

interface InitialState {
	one: RbidosLeadModel | null
}

const initialState: InitialState = {
	one: null,
}

export namespace leadOneNS {
	export type GetOne = PayloadAction<number>
	export type SetOne = PayloadAction<RbidosLeadModel>
	export type ClearOne = PayloadAction
	export type CreateOne = PayloadAction<{
		data: RbidosLeadCreateModel
		formName?: string
		callback?: Callback
		errorCallback?: Callback
	}>
}

export const leadOneSlice = createSlice({
	name: 'leadOne',
	initialState,
	reducers: {
		getOne: (state, action: leadOneNS.GetOne) => {},
		setOne: (state, action: leadOneNS.SetOne) => {
			state.one = action.payload
		},
		clearOne: (state, action: leadOneNS.ClearOne) => {
			state.one = null
		},
		createOne: (state, action: leadOneNS.CreateOne) => {},
	},
})
